import * as React from 'react';

export default function LinkBullet({props}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={45.27}
      height={45.27}
      viewBox="0 0 45.27 45.27"
      {...props}
    >
      <defs>
        <filter
          id="link-bullet-a"
          x={6.635}
          y={6.635}
          width={32}
          height={32}
          filterUnits="userSpaceOnUse"
        >
          <feOffset />
          <feGaussianBlur stdDeviation={4} result="blur" />
          <feFlood floodColor="red" floodOpacity={0.569} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="link-bullet-b"
          x={0}
          y={0}
          width={45.27}
          height={45.27}
          filterUnits="userSpaceOnUse"
        >
          <feOffset />
          <feGaussianBlur stdDeviation={4} result="blur-2" />
          <feFlood floodColor="red" floodOpacity={0.588} />
          <feComposite operator="in" in2="blur-2" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g data-name="Raggruppa 277">
        <g filter="url(#link-bullet-a)" transform="translate(.005 .005)">
          <circle
            data-name="Ellisse 66"
            cx={4}
            cy={4}
            r={4}
            transform="translate(18.63 18.63)"
            fill="red"
          />
        </g>
        <g filter="url(#link-bullet-b)" transform="translate(.005 .005)">
          <g
            data-name="Ellisse 172"
            transform="translate(12 12)"
            fill="none"
            stroke="red"
            strokeWidth={2}
          >
            <circle cx={10.635} cy={10.635} r={10.635} stroke="none" />
            <circle cx={10.635} cy={10.635} r={9.635} />
          </g>
        </g>
      </g>
    </svg>
  );
}
